export default "__VITE_ASSET__42a2ce47__"